import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'

import Loader from '../../atoms/Loader'
import Footer from '../../atoms/Footer'
import GridContainer from '../../atoms/FoundationGrid/GridContainer'
import Grid from '../../atoms/FoundationGrid/Grid'
import Cell from '../../atoms/FoundationGrid/Cell'
import GeneralInfo from '../../organisms/GeneralInfo'
import FundDetailTabs from '../../organisms/FundDetailTabs'
import PageLevelMessage from '../../atoms/PageLevelMessage'

import './style.scss'

const FundDetail = ({ generalInfo, tabsInfo, footerInfo, onTabChange }) => (
  <div className="fil-fund-detail">
    {generalInfo?.newLaunchWarningMsg && (
      <GridContainer>
        <Grid extraClasses="fil-fund-detail__before-launch-msg-container align-center">
          <Cell extraClasses="small-12 large-8 fil-fund-detail__before-launch-msg">
            <PageLevelMessage status="warning" content={generalInfo?.newLaunchWarningMsg} />
          </Cell>
        </Grid>
      </GridContainer>
    )}
    <div
      className={classnames('fil-fund-detail__section fil-fund-detail__header', {
        'loading grid-x align-middle align-center': !generalInfo
      })}
    >
      {generalInfo ? <GeneralInfo generalInfo={generalInfo} /> : <Loader />}
    </div>
    <div
      className={classnames('fil-fund-detail__section fil-fund-detail__body', {
        'loading grid-x align-middle align-center': !tabsInfo
      })}
    >
      {tabsInfo ? <FundDetailTabs {...tabsInfo} onTabChange={onTabChange} /> : <Loader />}
    </div>
    <div
      className={classnames('fil-fund-detail__section', {
        'loading grid-x align-middle align-center': !footerInfo
      })}
    >
      {footerInfo ? (
        <GridContainer>
          <Grid direction="grid-x">
            <Footer {...footerInfo} />
          </Grid>
        </GridContainer>
      ) : (
        <Loader />
      )}
    </div>
  </div>
)

FundDetail.propTypes = {
  generalInfo: PropTypes.object,
  tabsInfo: PropTypes.object,
  footerInfo: PropTypes.object,
  onTabChange: PropTypes.func
}

FundDetail.defaultProps = {
  generalInfo: null,
  tabsInfo: null,
  footerInfo: null,
  onTabChange: () => {}
}

export default FundDetail
